module.exports = __webpack_public_path__ + "ec1da482c0dc92d6c61757ed6584426d.svg";